import { scaffolderPlugin } from "@backstage/plugin-scaffolder";
import { createScaffolderFieldExtension } from "@backstage/plugin-scaffolder-react";
import { CurrentUserField } from "./CurrentUserField";

// @TODO Fix the typing issues
export const CurrentUserFieldExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: "CurrentUserField",
    component: CurrentUserField,
  })
);
